import React from "react";
import classNames from "classnames";
import DropdownFilter from "component/dropdownFilter/DropdownFilter";
import type { FilterPanelProps } from "./types";
import "./FilterPanel.scss";
import "pages/detailPicker/detailPicker.scss";

export const FilterPanel = ({
  title,
  layout,
  children,
  testId,
  isOpen,
  collapseTable,
}: FilterPanelProps): JSX.Element => {
  return (
    <DropdownFilter
      className="dropdown-wrapper--filter-panel"
      title={title}
      testId={testId}
      isOpen={isOpen}
      collapseTable={collapseTable}
    >
      <div className={classNames("filter-panel", `filter-panel--${layout}`)}>
        {children}
      </div>
    </DropdownFilter>
  );
};

export default FilterPanel;
